//--------------------------------------------
//
// Middle level scene that is all HTML Dom elements
//
//--------------------------------------------
'use strict';

import moment from 'moment';
import SmoothScroll from 'smoothscroll';

import Notification from './Notifications';
import ChatMessage from './ChatMessage';
import AudioManager from './AudioManager';
import RandomUser from './RandomUser';
import Timeline from './Timelines';


import CONSTANTS from './constants';

class DomScene {

	constructor(threeScene){

		//reference to underlying Skybox scene. used to generate particles on clicks
		this.threeScene = threeScene;

		//dom layer
		this.scene = document.getElementById('domScene');
		
		// Likes your post, etc...
		this.notifications = document.getElementsByClassName('notify');
		this.notificationInterval = null;

		this.time = document.getElementById('time');
		this.timer = null;
		
		//start of feature
		this.startOfFeature = document.getElementById('body-start');
		this.scrollDown = document.getElementById('scrollDown');

		

		this.timelineContainer = document.getElementById('timeline-container');
		

		//are we chatting?
		this.chatting = false;

		//timeline
		this.timeline = null;

		this.init();
	}

	init(){

		//this.scene.style.width = window.innerWidth + 'px';
		this.scene.style.height = window.innerHeight * CONSTANTS.HEIGHT_RATIO + 'px';

		this.notify();
	
		
		
	}

	
	//--------------------------------------------
	// Clock updates
	//
	handleTime(){
		const self = this;

		this.timer = setTimeout(() => {
			const time = new moment().format('h:mm:ss a');
			self.time.innerHTML =`<h2>${time}</h2>`;

			self.handleTime();
		}, 1000);
	}


	// ------------------------------------------------
	// Start timeline stuff after first click
	//
	startTimeline(){

		//initial chat
		this.chatRequest = new ChatMessage(this.threeScene);
		this.chatEl = this.chatRequest.el();

		this.handleTime();
		this.startTimelineLoop();
		this.startChatLoop();
		this.addListeners();
	}



	//--------------------------------------------
	// Chats
	//
	startChatLoop(){
		const self = this;
		this.chatTimer = setTimeout(() => {
			
			//if there is already a visible chat, just keep looping
			if (this.chatEl.childNodes.length > 0){
				self.startChatLoop();
			}

			//otherwise, make a new chat
			else{
				self.chatRequest = new ChatMessage(self.threeScene);
				self.chatEl = self.chatRequest.el();
				self.startChatLoop();
			}
		})
	}


	startTimelineLoop(){

		const self = this;
		console.log('hit');

		this.timelineTimer = setTimeout(() => {
			
			const nodes = self.timelineContainer.getElementsByTagName('li');

			if (nodes.length > 0){
				self.startTimelineLoop();
			}

			else{
				self.timeline = new Timeline(self.threeScene).then((el) => {
					setTimeout(() => {
						el.classList.add('visible')
					},400);
				});

				self.startTimelineLoop();
			}
		}, this.randomInterval(
			CONSTANTS.TIMELINE_RATE[0],
			CONSTANTS.TIMELINE_RATE[1]
		))
	}
			

	//--------------------------------------------
	// Create new notification
	//		
	notify(){
		const self = this;
		this.notifications = document.getElementsByClassName('notify');


		this.notificationInterval = setTimeout(() => {

			if (self.notifications.length < 2){
				
				//passing in underlying THREE scene to trigger particles on click
				const notification = new Notification(self.threeScene);

				AudioManager.onNotification();
				
				//make another notification
				self.notify();
			}

			else {

				self.notify();
			}
			
		}, this.randomInterval(
			CONSTANTS.NOTIFICATION_RATE[0],
			CONSTANTS.NOTIFICATION_RATE[1]
		));
	}


	//--------------------------------------------
	// Random interval used for notifications control
	//		
	randomInterval(min, max){
		return Math.floor(Math.random() * (max - min + 1) + min);
	}


	//--------------------------------------------
	// Bind listeners
	//	
	addListeners(){
		this.scrollDown.addEventListener('click', this.onScrollClick.bind(this), false);
		window.addEventListener('mousemove', this.onMouse.bind(this), false);
		window.addEventListener('resize', this.onResize.bind(this), false);

	}

	//--------------------------------------------
	// Mouse movements
	//		
	onMouse(ev){
		const x = (ev.pageX - (window.innerWidth / 2)) / 100;
		const y = (ev.pageY - (window.innerHeight / 2)) / 100;

		//rotate domScene based on mouse
		this.scene.style.transform = `rotateX(${y}deg) rotateY(${x}deg) translateZ(100px)`;
	}


	onResize(){
		//this.scene.style.width = window.innerWidth + 'px';
		this.scene.style.height = window.innerHeight * CONSTANTS.HEIGHT_RATIO + 'px';
	}



	//--------------------------------------------
	// Chat bubble click
	//
	onChatBubbleClick(ev){
		this.chatRequest.classList.remove('chatting');
		this.chatBubble.classList.remove('chatting');
		this.chatRequest.classList.remove('active');
		this.chatting = false;
	}

	//--------------------------------------------
	// Click scroll down
	//
	onScrollClick(ev){
		SmoothScroll(this.startOfFeature, 1000);
	}

}


export default DomScene;